import { apiPostRequest, apiGetRequest } from "../utils/webrequests";
import { CommunicationType } from "../data/CommunicationType";

/**
 * Fetch all communication types.
 */
export async function getCommunicationTypes(): Promise<CommunicationType[]> {
    try {
        const data: CommunicationType[] = await apiGetRequest("GetComTypeList", {});
        if (!data) {
            throw new Error("No data received from API");
        }
        return data;
    } catch (error: any) {
        console.error("Error fetching communication types:", error);
        throw new Error("Error fetching communication types: " + error.message);
    }
}

/**
 * Add or update a communication type.
 */
export async function addOrUpdateCommunicationType(type: CommunicationType): Promise<string> {
    try {
        const response: string = await apiPostRequest("SaveComType", type);
        return response;
    } catch (error: any) {
        console.error("Error saving communication type:", error);
        throw new Error("Error saving communication type: " + error.message);
    }
}

/**
 * Delete a communication type.
 */
export async function deleteCommunicationType(comTypeId: string): Promise<string> {
    try {
        const response: string = await apiPostRequest(`DeleteComType/${comTypeId}`, {}); // 👈 fix here
        return response;
    } catch (error: any) {
        console.error("Error deleting communication type:", error);
        throw new Error("Error deleting communication type: " + error.message);
    }
}
